'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var storeHelper = require('../../helper/storeHelper');
var assetsHelper = require('../../helper/assetsHelper');
var i18nHelper = require('../../helper/i18n');
var dateTimeHelper = require('../../helper/dateTimeHelper');
var ScrollView = require('osx-scrollview');

var testData = '[{"id":548,"content":"dsfcsd","addtime":"2017-05-04T06:40:36.000Z","author":"sdvgf"},{"id":549,"content":"dxvcs","addtime":"2017-05-04T06:40:43.000Z","author":"sdvgf"},{"id":550,"content":"zxvcd","addtime":"2017-05-04T06:40:48.000Z","author":"sdvgf"},{"id":551,"content":"dvc","addtime":"2017-05-04T06:40:49.000Z","author":"sdvgf"},{"id":552,"content":"sd","addtime":"2017-05-04T06:40:50.000Z","author":"sdvgf"},{"id":553,"content":"svcd","addtime":"2017-05-04T06:40:52.000Z","author":"sdvgf"},{"id":554,"content":"dsv","addtime":"2017-05-04T06:40:52.000Z","author":"sdvgf"},{"id":555,"content":"v","addtime":"2017-05-04T06:40:54.000Z","author":"sdvgf"},{"id":566,"content":"sdv","addtime":"2017-05-04T06:40:55.000Z","author":"sdvgf"},{"id":574,"content":"xzvc","addtime":"2017-05-04T06:40:57.000Z","author":"sdvgf"},{"id":575,"content":"ds","addtime":"2017-05-04T06:41:01.000Z","author":"sdvgf"},{"id":576,"content":"sdv","addtime":"2017-05-04T06:41:02.000Z","author":"sdvgf"},{"id":577,"content":"dsvsdf","addtime":"2017-05-04T06:41:05.000Z","author":"sdvgf"}]';
var testComments = JSON.parse(testData);


function convertToReadableDate(datestr) {
  return datestr.substring(0, datestr.length - 8).replace('T', ' ');
}

var PageComments = React.createClass({
  propTypes: {
    comments: React.PropTypes.array,
    onAddComment: React.PropTypes.func.isRequired,
    onLoadComment: React.PropTypes.func.isRequired,
    onError: React.PropTypes.func.isRequired,
    sign: React.PropTypes.func.isRequired,
    onClearError: React.PropTypes.func.isRequired,
  },
  getInitialState: function () {
    return {
      content: '',
      hasSign: !!storeHelper.get('sign'),
      sign: storeHelper.get('sign')
    };
  },
  componentWillReceiveProps: function (nextProps) {
    if (nextProps.comments.length !== this.props.comments.length) {
      this.setState({
        content: ''
      });
    }
  },
  focusReset: false,
  adjustCommentList: function() {
    var scroll = ReactDOM.findDOMNode(this.refs.flex);
    var scrollContent = $(scroll).find('.scroll-content');
    $(scrollContent).scrollTop(10000);

    var height = $('.comment-list').height();
    var width = $('.comment-list').width();
    $(scroll).css({position: 'absolute', right: 10, height: height, width: width});

  },
  componentDidUpdate: function () {
    if(!this.state.hasSign && this.focusReset) {
      var node = ReactDOM.findDOMNode(this.refs.signName);
      var text = $(node).val();
      $(node).val("").focus().val(text);
      this.focusReset = false;
    }
    this.adjustCommentList();

  },
  componentDidMount: function() {
    var reactContext = this;
    window.onkeydown = function (e) {
      if(e.keyCode == 13 && e.ctrlKey) {
        reactContext.onSubmitComment();
      }
    };
    this.adjustCommentList();
  },
  render: function () {
    var comments = this.props.comments;
    //var comments = testComments;
    //console.log(comments);
    var sign = storeHelper.get('sign');
    return (
      <div className="page-comments">
          <div className="comment-list" ref="list">
            <ScrollView ref='flex'>
            {
              comments.map(function (item) {
                if (item.author === sign) {
                  return (
                    <div className="item item-mine" key={item.id}>
                      <p className="content content-mine">{item.content}</p>
                      <div className="right-time">{dateTimeHelper.readableTime(item.addtime)}</div>
                    </div>
                  );
                }
                return (
                  <div className="item" key={item.id}>
                    <div className="title">
                      <span className="author">{item.author}</span>
                      <span className="time">{convertToReadableDate(item.addtime)}</span>
                    </div>
                    <div className="content">
                      {item.content}
                    </div>
                  </div>
                );
              }, this)
            }
            </ScrollView>
          </div>

        <div className="new-comment">
          <textarea onChange={this.onCommentChange} placeholder={i18nHelper.get('COMMENT_HINT')} value={this.state.content}></textarea>
          <div className="submit">
            <div className="sign">
              <span className="lab">{i18nHelper.get('SIGN_LABEL')}</span>
              {this.state.hasSign &&
              <span className="name">{this.state.sign}</span>
              }
              {this.state.hasSign &&
              <img onClick={this.onResetSign} src={assetsHelper.getAsset('/review/icon_edit_name.png')}
                   alt="reset name"/>
              }
              {this.state.hasSign ||
              <input ref='signName' type="text" value={this.state.sign} onChange={this.setSign} placeholder={i18nHelper.get('SIGN_HINT')}/>
              }
            </div>
            <button className={this.state.sign && this.state.sign.trim() && this.state.content.trim() || 'disabled'}
                    onClick={this.onSubmitComment}>{i18nHelper.get('SUBMIT')}
            </button>
          </div>
        </div>
      </div>
    );
  },
  setSign: function (e) {
    this.setState({
      sign: e.target.value
    });
  },
  onResetSign: function () {
    this.focusReset = true;
    this.setState({
      hasSign: false,
    });
  },
  onCommentChange: function (e) {
    this.setState({
      content: e.target.value
    });
  },
  clearErrorCallback: function() {
    this.props.onClearError();
    this.onResetSign();
  },
  onSubmitComment: function () {
    if (!this.state.sign || !this.state.sign.trim()) {
      return this.props.onError(i18nHelper.get('ENTER_SIGN'), this.clearErrorCallback);
    }
    this.props.sign(this.state.sign.trim());
    if(this.state.sign.trim() && this.state.content.trim()) {
      this.props.onAddComment(this.state.sign.trim(), this.state.content.trim());
    }
    this.setState({
      content: '',
      hasSign: true
    });
  }
});

module.exports = PageComments;


// WEBPACK FOOTER //
// ./src/views/Review/PageComments.jsx